import { Link, Navigate, useParams } from 'react-router-dom';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { JsonLdBlogPost } from '../components/JsonLdBlogPost';
import { Seo } from '../components/Seo';
import { SimpleMarkdown } from '../components/SimpleMarkdown';
import { getBlogPost } from '../lib/blogPosts';

export function BlogArticlePage() {
  const { slug } = useParams();
  const post = slug ? getBlogPost(slug) : undefined;

  if (!post) {
    return <Navigate to="/kennisbank" replace />;
  }

  return (
    <>
      <Seo
        path={`/kennisbank/${post.slug}`}
        title={post.title}
        description={post.description}
        keywords={post.keywords}
        articlePublishedTime={post.datePublished}
      />
      <JsonLdBlogPost
        title={post.title}
        description={post.description}
        datePublished={post.datePublished}
        path={`/kennisbank/${post.slug}`}
      />
      <article className="mx-auto max-w-3xl px-4 py-10 sm:py-14">
        <Breadcrumbs
          items={[
            { label: 'Home', to: '/' },
            { label: 'Kennisbank', to: '/kennisbank' },
            { label: post.title },
          ]}
        />
        <header className="mt-6">
          <time className="text-sm font-medium text-ct-muted" dateTime={post.datePublished}>
            {new Date(post.datePublished).toLocaleDateString('nl-NL', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
            })}
          </time>
          <h1 className="mt-3 text-3xl font-bold tracking-tight text-ct-text sm:text-4xl">{post.title}</h1>
          <p className="mt-4 text-pretty text-lg leading-relaxed text-ct-muted">{post.description}</p>
        </header>

        <div className="prose-muted ct-prose-muted mt-10 text-sm leading-relaxed text-ct-muted sm:text-base">
          <SimpleMarkdown text={post.body} />
        </div>

        <footer className="mt-12 rounded-2xl border border-ct-accent/25 bg-gradient-to-br from-ct-accent/10 to-transparent p-6 sm:p-8">
          <p className="text-sm font-semibold text-ct-text">Volgende stap in de app</p>
          <p className="mt-2 text-sm text-ct-muted">
            Zet je nieuwe inzicht om in concrete cijfers voor jouw woning of pand — binnen enkele minuten.
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <Link
              to="/scan"
              className="inline-flex rounded-xl bg-ct-accent px-5 py-2.5 text-sm font-bold text-white hover:bg-blue-500"
            >
              Start de ComfortTool-scan
            </Link>
            <Link
              to="/prijzen"
              className="inline-flex rounded-xl border border-ct-border px-5 py-2.5 text-sm font-semibold text-ct-text hover:bg-ct-elevated"
            >
              Bekijk prijzen
            </Link>
          </div>
        </footer>

        <p className="mt-8 text-center">
          <Link to="/kennisbank" className="text-sm font-medium text-ct-accent hover:underline">
            ← Terug naar kennisbank
          </Link>
        </p>
      </article>
    </>
  );
}
